export const API_URL = "https://api.magatra.site/api";
export const siteUrl = "https://magatra.site";